import type {ReactNode, MouseEvent} from 'react';
import React from 'react';
import classNames from 'classnames';

import {TypographySize, useTypography} from '../../../hooks/typography';

import styles from './styles.module.css';

export type ButtonActionProps = {
    icon?: ReactNode;
    name?: string;
    onClick?: (e: MouseEvent) => void;
    active?: boolean;
    className?: string;
    stretch?: boolean;
};

export const ButtonAction = React.forwardRef<HTMLButtonElement, ButtonActionProps>((props, ref) => {
    const typographyCls = useTypography({
        size: TypographySize.BodyXSSTrue,
    });

    const icon = props.icon ? <div className={styles.icon}>{props.icon}</div> : null;
    const name = props.name ? <div className={classNames(typographyCls, styles.name)}>{props.name}</div> : null;
    const className = classNames(styles.button, props.className, {
        [styles.active]: props.active,
        [styles.stretch]: props.stretch,
    });

    return (
        <button ref={ref} type='button' className={className} onClick={props.onClick}>
            {icon}
            {name}
        </button>
    );
});
